<template>
  <v-app-bar color="primary" height="40" fixed style elevation="2" dark>
    <v-btn height="100%" :to="'/projects/'" small text dark elevation="0">
      <v-icon v-text="'mdi-arrow-left'"></v-icon>
    </v-btn>
    <v-divider vertical></v-divider>
    <v-toolbar-title class="ml-4 mr-4" style="font-weight: bold">{{
      selectedProject.name
    }}</v-toolbar-title>
    <v-btn
      v-if="selectedProject.id"
      height="100%"
      :to="'/project/' + selectedProject.id + '/pages'"
      small
      text
      dark
      elevation="0"
      id="pages-button"
      >Pages</v-btn
    >
    <v-divider vertical></v-divider>
    <v-btn
      v-if="selectedProject.id"
      height="100%"
      :to="'/project/' + selectedProject.id + '/editor'"
      small
      text
      dark
      elevation="0"
      id="editor-button"
      >Editor</v-btn
    >
    <v-divider vertical></v-divider>
    <v-btn
      v-if="selectedProject.id"
      height="100%"
      :to="'/project/' + selectedProject.id + '/settings'"
      small
      text
      dark
      elevation="0"
      id="settings-button"
      >Settings</v-btn
    >
    <v-divider vertical></v-divider>
    <v-btn
      v-if="selectedProject.id"
      height="100%"
      :to="'/project/' + selectedProject.id + '/blog'"
      small
      text
      dark
      elevation="0"
      id="blog-button"
      >Blog</v-btn
    >
    <!-- <v-divider vertical></v-divider>
    <v-btn
      v-if="selectedProject.id"
      height="100%"
      :to="'/project/' + selectedProject.id + '/stats'"
      small
      text
      dark
      elevation="0"
      id="stats-button"
      >Stats</v-btn
    > -->
    <v-divider vertical></v-divider>
    <v-progress-circular
      v-if="saveBlockConfigLoading || updatePageLoading"
      indeterminate
      color="white"
      size="20"
      style="margin-left: 10px"
    ></v-progress-circular>
    <v-spacer></v-spacer>

    <!-- online users -->
    <span v-for="user in onlineUsers" :key="user.id">
      <UserAvatar
        :avatarUrl="user.avatarUrl"
        :fullName="user.fullName"
        :title="user.fullName + ' is working on this project'"
      />
    </span>

    <v-divider vertical></v-divider>

    <!-- preview buttons -->
    <div id="preview-buttons" v-if="isInEditorPage">
      <v-btn
        icon
        @click="SET_SELECTED_RESOLUTION('desktop')"
        :color="selectedResolution === 'desktop' ? 'black' : 'white'"
      >
        <v-icon small>mdi-monitor</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="SET_SELECTED_RESOLUTION('tablet')"
        :color="selectedResolution === 'tablet' ? 'black' : 'white'"
      >
        <v-icon small>mdi-tablet</v-icon>
      </v-btn>
      <v-btn
        icon
        @click="SET_SELECTED_RESOLUTION('mobile')"
        :color="selectedResolution === 'mobile' ? 'black' : 'white'"
      >
        <v-icon small>mdi-cellphone</v-icon>
      </v-btn>
    </div>
    <v-divider vertical></v-divider>
    <v-menu
      :offset-y="true"
      :close-on-content-click="false"
      v-model="publishConfirmMenu"
      transition="slide-y-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          height="100%"
          small
          text
          dark
          elevation="0"
          id="publish-button"
          v-on="on"
        >
          Publish
          <v-icon small text style="margin-left: 5px">mdi-earth</v-icon>
        </v-btn>
      </template>
      <v-card style="width: 300px" class="pa-2">
        <v-alert border="left" text type="info"
          >Publish your website with the new changes?</v-alert
        >
        <v-btn
          color="primary"
          style="text-align: center; width: 100%"
          @click="publishProject()"
          :loading="publishLoading"
          :disabled="publishLoading"
          >Confirm</v-btn
        >
      </v-card>
    </v-menu>

    <v-divider vertical></v-divider>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          height="100%"
          small
          text
          dark
          @click="visitProject()"
          elevation="0"
          id="view-button"
          v-on="on"
        >
          View
          <v-icon small style="margin-left: 10px">mdi-open-in-new</v-icon>
        </v-btn>
      </template>
      <span>View your website</span>
    </v-tooltip>

    <v-divider vertical></v-divider>
    <ConsoleDropdownMenu></ConsoleDropdownMenu>
  </v-app-bar>
</template>

<script>
import { mapMutations } from "vuex";
import projectMixin from "./project-mixin";
import ConsoleDropdownMenu from "../ConsoleDropdownMenu";
import UserAvatar from "../UserAvatar.vue";

export default {
  components: { ConsoleDropdownMenu, UserAvatar },
  mixins: [projectMixin],
  data() {
    return { publishConfirmMenu: false };
  },
  watch: {
    publishLoading(val) {
      if (val == false) {
        this.publishConfirmMenu = false;
      }
    },
  },
  computed: {
    isInEditorPage() {
      return this.$route.path.indexOf("/editor") > -1;
    },
  },
  methods: {
    ...mapMutations({
      SET_SELECTED_RESOLUTION: "project/SET_SELECTED_RESOLUTION",
    }),
    visitProject() {
      window.open("https://" + this.selectedProject.computedDomain);
    },
  },
};
</script>

<style>
.v-toolbar__content {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>